import type { District } from '../plot.ts'
import { decals, look, row, woodsy } from '../kit.ts'

/** Sakura Hill: cherry trees, a red pagoda, torii over the path, a zen garden and the teahouse. */
export const sakura: District = {
  id: 'sakura',
  name: 'Sakura Hill',
  ground: 'moss',
  ambience: ['petals', 'fireflies'],
  build(p) {
    p.zone(16, 0, 3, 32, 'canal')
    p.zone(0, 15, 36, 2, 'gravel'); p.zone(16, 15, 3, 2, 'bridge')
    p.zone(25, 8, 1, 7, 'gravel'); p.zone(6, 7, 1, 8, 'gravel')
    p.zone(2, 20, 11, 9, 'gravel')
    p.prop(
      { kind: 'gate', x: 23, y: 14, w: 1, d: 4, variant: 'torii' }, { kind: 'gate', x: 27, y: 14, w: 1, d: 4, variant: 'torii' }, { kind: 'gate', x: 31, y: 14, w: 1, d: 4, variant: 'torii' },
      { kind: 'stonelantern', x: 21, y: 13 }, { kind: 'stonelantern', x: 29, y: 13 }, { kind: 'stonelantern', x: 21, y: 18 }, { kind: 'stonelantern', x: 29, y: 18 },
      { kind: 'stonelantern', x: 5, y: 13 }, { kind: 'stonelantern', x: 8, y: 18 },
      { kind: 'building', x: 22, y: 3, w: 7, d: 5, door: 3, style: 'teahouse', color: '#f3e6d0', roof: '#4a4f5a', text: 'Sakura Tea', enter: 'teahouse' },
      { kind: 'building', x: 4, y: 2, w: 5, d: 5, style: 'pagoda', h: 3, color: '#c0392b', roof: '#2f3640' },
      { kind: 'rock', x: 4, y: 22 }, { kind: 'rock', x: 9, y: 24 }, { kind: 'rock', x: 5, y: 26 }, { kind: 'rock', x: 11, y: 21 },
      { kind: 'pond', x: 22, y: 21, w: 7, d: 5 },
      { kind: 'bench', x: 23, y: 27, face: 1 },
    )
    p.tram(31, 26)
    p.place({ id: 'sakura', name: 'Sakura Hill', blurb: 'Torii over the path, a pagoda, and petals on the river.', x: 29, y: 16, accent: '#ff9cc2', r: 11 })
    p.place({ id: 'zen', name: 'Zen Garden', blurb: 'Raked gravel and four stones. Sit a while.', x: 7, y: 27, accent: '#c9c3bb', r: 4 })
    p.scatter({ density: 0.2, pick: woodsy([['sakura', 7], ['pine', 1], ['bush', 1]]), on: ['moss'] })
    p.scatter({ density: 0.55, pick: woodsy([['bamboo', 1]]), on: ['moss'], rect: [0, 0, 3, 14] })
    p.critter({ kind: 'koi', loop: [[23, 22.3], [27.6, 22.6], [27.4, 24.8], [23.2, 24.6]], speed: 0.4 })
    p.critter({ kind: 'koi', loop: [[26.5, 24.2], [23.8, 23.4], [25.2, 22.2]], speed: 0.3 })
    p.critter({ kind: 'butterfly', loop: [[20, 6], [30, 10], [33, 2], [21, 1]], speed: 0.5 })
    p.npc({
      id: 'npc-ume', name: 'Sensei Ume', role: 'Gardener', look: look('senseiume', 0, 21, 1, 'beret'), speed: 0.9,
      stops: [
        { x: 7, y: 27, wait: 30, emote: 'thinking', say: -1 },
        { x: 6, y: 9, wait: 12, say: -1 },
        { x: 25, y: 9, wait: 10, emote: 'happy' },
        { x: 28, y: 16, wait: 14, say: -1 },
      ],
      lines: ['Every stone has its place. Even you.', 'Tea is ready when it is ready.', 'Listen. That is the river.', 'The petals fall so the tree can rest.'],
    })

    // ─── Detail ───
    p.scatter(decals(['petals', 'petals', 'moss'], 0.18, ['moss', 'gravel']))
    p.prop(
      { kind: 'well', x: 12, y: 18 }, { kind: 'festoon', x: 33, y: 14, w: 1, d: 4, variant: 'lanterns' },
      ...row('fence', 2, 12, 19), { kind: 'pot', x: 21, y: 8, variant: 'bonsai' }, { kind: 'pot', x: 29, y: 8, variant: 'bonsai' },
      { kind: 'reeds', x: 21, y: 26 }, { kind: 'reeds', x: 29, y: 24 },
    )
    p.npc({
      id: 'npc-ren', name: 'Ren', role: 'Temple sweeper', look: look('sweeperren', 1, 20, 1, 'none'), speed: 0.8,
      stops: [{ x: 6, y: 8, wait: 15, say: -1 }, { x: 12, y: 15, wait: 15 }, { x: 20, y: 16, wait: 10, emote: 'happy', say: -1 }],
      lines: ['Sweep the path, and the path sweeps you.', 'The petals always come back. That is the point.', 'Welcome. Mind the koi.'],
    })
  },
}
